import React from 'react';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import TrustedBy from '../components/TrustedBy';
import Stats from '../components/Stats';
import FAQ from '../components/FAQ';
import { ArrowRight, TrendingUp, Target, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();
  
  const benefits = [
    {
      icon: TrendingUp,
      title: t('benefits.growth.title'),
      description: t('benefits.growth.description')
    },
    {
      icon: Target,
      title: t('benefits.insights.title'),
      description: t('benefits.insights.description')
    },
    {
      icon: Zap,
      title: t('benefits.implementation.title'),
      description: t('benefits.implementation.description')
    }
  ];

  return (
    <div className="page-home">
      <Hero />
      <HowItWorks />
      
      <section className="benefits-section">
        <div className="benefits-container">
          <div className="section-header">
            <h2 className="section-title">{t('benefits.title')}</h2>
            <p className="section-subtitle">
              {t('benefits.subtitle')}
            </p>
          </div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon">
                    <Icon size={40} />
                  </div>
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Stats />
      <TrustedBy />
      <FAQ />

      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">{t('cta.title')}</h2>
          <p className="cta-subtitle">
            {t('cta.subtitle')}
          </p>
          <div className="cta-buttons">
            <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large">
              {t('cta.scheduleConsultation')}
              <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;